import prodConfig from "./Configs/config.prod";
import devConfig from "./Configs/config.dev";

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

export default config;
